export const SIGNATURE_TRIGGER_OPTIONS = {
  ON_NEW_ACCOUNT: 'On New Account',
  ON_FIRST_TICKET: 'On First Ticket',
  ON_FIRST_INVOICE: 'On First Invoice',
  MANUAL_ONLY: 'Manual Only'
}

export const SIGNATURE_TRIGGER_HELPER_TEXT = {
  ON_NEW_ACCOUNT: '*This agreement will be sent automatically when the account is created.',
  ON_FIRST_TICKET: '*This agreement will be sent automatically when the customer\'s first ticket is created.',
  ON_FIRST_INVOICE: '*This agreement will be sent automatically: On First Invoice.',
  MANUAL_ONLY: '*This agreement will be sent automatically: Manual Only.'
}

export const AGREEMENT_INFO_TIP = 'This agreement will be sent automatically based on the agreement\'s signature trigger.'

export const DELIVERY_OPTIONS = {
  SMS_EMAIL: 'SMS + Email',
  EMAIL: 'Email',
  SMS: 'SMS'
}

export const LINK_EXPIRATION_OPTIONS = {
  7: '7 Days',
  30: '30 Days',
  60: '60 Days',
  90: '90 Days',
  CUSTOM: 'Custom'
}

export const NOTIFY_OPTIONS = {
  YES: 'Yes',
  NO: 'No'
}

export const DEFAULT_TEMPLATE_TIP = 'Only one template can be set as the default to automatically apply to all new Accounts. If no default is set, ' +
'Terms and Conditions must be selected manually for each new Account.'

export const WARN_TICKET_TIP = ' Display a notification when creating a Ticket for an Account whose Terms and Conditions link expired before the customer signed it.'

export const WARN_INVOICE_TIP = ' Display a notification when creating an Invoice for an Account whose Terms and Conditions link expired before the customer signed it.'

export const AGREEMENT_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled'
}

export const NO_TC_AGREEMENT_VALUE = 'none'

export const INITIAL_VALUES = {
  name: '',
  isDefault: false,
  content: '',
  warnTicketCreation: false,
  warnInvoicePayment: false,
  signatureTrigger: '',
  defaultDelivery: '',
  linkExpiration: '',
  customDays: '',
  notifyAdminOnSign: ''
}
